/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotesIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconStickyNotes from 'DesignSystem/Svgs/TysiaIconStickyNotes/index'



/** @type {import('Simple/types.js').View} */
export default function NotesIcon({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/AlertIcon/NotesIcon"
  
}) {
let dtColorsOrange400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.400'
        })
  return (<React.Fragment
>
<TysiaIconStickyNotes
  viewPath={`${viewPath}/TysiaIconStickyNotes`}
 width={32}
 height={32}
 fill={dtColorsOrange400}
/>
{children}
</React.Fragment>)
}